export default __webpack_public_path__ + "static/media/57SA82_57SD82_57SL82_57SJ82_57SK82.8f2100fe.png";